import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import * as Sentry from '@sentry/react';
import { msalConfig } from 'helpers/authConfig';
import { initializeSentry } from 'helpers/sentry';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import App from './ReactGridLayout';
// import App from './ReactBeautifulDndGrid';
// import reportWebVitals from './reportWebVitals';

initializeSentry();

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <Sentry.ErrorBoundary
    fallback={() => <p>Something went wrong in Screenz</p>}
    showDialog
  >
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//  console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
